import { gql } from '@apollo/client';

export const NOTE_FIELDS = gql`
  fragment NoteFields on Note {
    id
    objectId
    objectType
    content
    tenantId
    ownerId
    ownerEmail
    createdAt
    updatedAt
  }
`;

export const GET_NOTES_FOR_OBJECT = gql`
  ${NOTE_FIELDS}
  query GetNotesForObject($objectId: String!) {
    getNotesForObject(objectId: $objectId) {
      ...NoteFields
    }
  }
`;

export const CREATE_NOTE = gql`
  ${NOTE_FIELDS}
  mutation CreateNote($input: CreateNoteInput!) {
    createNote(input: $input) {
      ...NoteFields
    }
  }
`;

export const DELETE_NOTE = gql`
  mutation DeleteNote($id: String!) {
    deleteNote(id: $id)
  }
`;
